import React from "react"
import styled from "styled-components/macro"
import colors from "../../../scripts/colors"
import HomeIntroParagraph from "./HomeIntroParagraph"
import HomeIntroMedia from "./HomeIntroMedia"
import HomeIntroGallery from "./HomeIntroGallery"
import HomeIntroLinks from "./HomeIntroLinks"
import useFacilityData from "../../../hooks/useFacilityData.ts"

const HomeIntroStyles = styled.section`
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  margin-bottom: 120px;
`

const HomeIntroTextMedia = styled.div`
  width: 100%;
  flex-shrink: 0;
  margin-right: 50px;
  &.HomeIntroContent--noGallery {
    margin-right: 0;
  }
  @media screen and (min-width: 1024px) {
    width: 450px;
    &.HomeIntroContent--noGallery {
      width: 100%;
    }
  }
  @media screen and (min-width: 1500px) {
    width: 800px;
    &.HomeIntroContent--noGallery {
      width: 100%;
    }
  }
`

const HomeIntroContent = () => {
  const pageData = useFacilityData()

  const data = pageData.sanityFacility.facilityObj

  const galleryArr = data.siteContent.initParagraphGallery

  const homeIntroTextMediaClass =
    galleryArr.length > 0
      ? "HomeIntroContent--withGallery"
      : "HomeIntroContent--noGallery"

  return (
    <HomeIntroStyles role="region">
      <HomeIntroTextMedia className={homeIntroTextMediaClass}>
        <HomeIntroParagraph
          title={data.siteContent.initParagraphTitle}
          text={data.siteContent.initParagraphText}
        />
        {data.video && data.video.youtubeUrl && (
          <HomeIntroMedia vidUrl={data.video.youtubeUrl} />
        )}
        <HomeIntroLinks />
      </HomeIntroTextMedia>
      {galleryArr.length > 0 && (
        <HomeIntroGallery
          imgArr={galleryArr}
          vidUrl={data.video.youtubeUrl}
          facilityName={data.facilityName}
        />
      )}
    </HomeIntroStyles>
  )
}

export default HomeIntroContent
